import {
  getContactArrayByType,
  moreMagicalSortingByTheInternalExternalUserStuff,
} from '../../../components/Navigation/Footer/whole-sale-sorter'
import { accessStorage } from '../../../spa/components/institutional/common/institutionalConfig.js'

export const getWholesalerFromcookies = () => {
  const RMInfo = accessStorage.getRMInfo()
  const RM_data = {
    preferredFirstNm: RMInfo?.name,
    emailId: RMInfo?.email,
    phoneNbr: RMInfo?.phone,
    titleCd: 'My Relationship Manager',
  }
  return RM_data
}
export const findAdvisor = (value, emailId) => {
  let advisorProfile

  value.forEach((areaName) => {
    areaName.salesContactInfo.forEach((advisor) => {
      if (advisor.emailId === emailId) {
        advisorProfile = advisor
      }
    })
  })

  return advisorProfile
}

export const getDisplayableWholeSalers = (profile) => {
  let wholeSalersToDisplay = []

  // start with primary
  if (profile) {
    const primarySalesContactInfo = getContactArrayByType(
      profile.salesContactByChannel,
      'Y'
    )

    if (primarySalesContactInfo && primarySalesContactInfo.length > 0) {
      // we need to sort the primaries...
      primarySalesContactInfo[0].salesContactInfo.sort(
        moreMagicalSortingByTheInternalExternalUserStuff
      )
      wholeSalersToDisplay =
        primarySalesContactInfo[0].salesContactInfo.slice(0)
    }

    return wholeSalersToDisplay
  }
}
